import React, { useState } from 'react';
import { ExpandMore } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import LoginWithName from '../LoginWithName/LoginWithName';

import styles from './LoginAdminMobile.module.scss';

function LoginAdminMobile(): JSX.Element {
  const { t } = useTranslation();
  const [displayLoginWithEmail, setDisplayLoginWithEmail] = useState(false);

  const handleChangeLoginWithEmail = () => {
    setDisplayLoginWithEmail(!displayLoginWithEmail);
  };

  return (
    <div>
      <div
        className={
          displayLoginWithEmail ? styles.containerOpen : styles.containerNotOpen
        }
      >
        <div className={styles.title} onClick={handleChangeLoginWithEmail}>
          <legend>
            <span>{t('LABEL_ALREADY_ORDERED')}</span>
            <span>
              <ExpandMore fontSize="large" />
            </span>
          </legend>
        </div>
        {displayLoginWithEmail && (
          <div className={styles.form}>
            <LoginWithName />
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginAdminMobile;
